module.exports = __webpack_public_path__ + "img/onboarding-plane.b00f6158.svg";